import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';
import { source } from '@/plugins/papybase/papybaseInit';
import { MUTATE_SOURCES } from '@/store/modules/interface';
import { Component, Mixins } from 'vue-property-decorator';

@Component
export default class SourceIntegrationMixin extends Mixins(GAErrorEvent) {
    public created() {
        this.integrateSourcesFromBackEndToLocalStorage().catch((err) => {
            console.error(err);
        });
    }

    public async integrateSourcesFromBackEndToLocalStorage() {
        try {
            const list = await source.list();
            this.$store.commit(MUTATE_SOURCES, list);
        } catch (error) {
            this.errorEvent('source list', error);
            throw new Error(error);
        }
    }
}
